    import { Fragment, useEffect, useState } from "react";
    import { useNavigate } from "react-router-dom";
    import Header from "../../component/layout/header";
    import Footer from "../../component/layout/footer";
    import { useRef } from "react";
    import Swal from "sweetalert2";
    import { createPortal } from "react-dom";
  import { CKEditor } from "@ckeditor/ckeditor5-react";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


    import "./viewprofile.css";
  import UpgradeModal from "./UpgradeModal";
    const fallbackAds = [
      { imgUrl: "/assets/images/art/Sing1.png" },
      { imgUrl: "/assets/images/art/Sing2.png" },
      { imgUrl: "/assets/images/art/Sing3.png" },
    ];

  const statusLabels = {
    0: "Pending",
    1: "Approved",
    2: "Rejected"
  };

    /* ===================== */
    /* SKELETON COMPONENTS */
    /* ===================== */

    const AdsSkeleton = () => (
      <>
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="skeleton-box"
            style={{ height: "160px", marginBottom: "12px", borderRadius: "12px" }}
          />
        ))}
      </>
    );

    const ProfileSkeleton = () => (
      <div className="fun-card profile-card resume-profile w-100">
        <div className="skeleton-circle mx-auto mb-3"></div>
        <div className="skeleton-text w-60 mx-auto"></div>
        <div className="skeleton-text w-40 mx-auto"></div>
        <div className="skeleton-line mt-3"></div>
        <div className="skeleton-line"></div>
        <div className="skeleton-line"></div>
      </div>
    );

    const CardSkeleton = ({ height = 200 }) => (
      <div
        className="fun-card"
        style={{ height, marginBottom: "16px" }}
      >
        <div className="skeleton-line w-50"></div>
        <div className="skeleton-line"></div>
        <div className="skeleton-line"></div>
      </div>
    );


    const SideColumnSkeleton = () => (
      <div className="d-flex flex-column gap-3 w-100">
        {/* Personal Info Skeleton */}
        <div className="fun-card h-100">
          <div className="skeleton-text w-60 mb-3"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
        </div>

        {/* Awards Skeleton */}
        <div className="fun-card h-100">
          <div className="skeleton-text w-50 mb-3"></div>
          <div className="skeleton-box mb-2" style={{ height: 80 }}></div>
          <div className="skeleton-box" style={{ height: 80 }}></div>
        </div>
      </div>
    );


    

    const ViewProfile = () => {
      const navigate = useNavigate();
      const [tutor, setTutor] = useState(null);
      const [requests, setRequests] = useState([]);
      const [showAwardModal, setShowAwardModal] = useState(false);
      const [awardTitle, setAwardTitle] = useState("");
      const [awardLink, setAwardLink] = useState("");
      const [awardImage, setAwardImage] = useState(null);
      const [categories, setCategories] = useState([]);
      const [cities, setCities] = useState([]);
      const [states, setStates] = useState([]);
      const [countries, setCountries] = useState([]);
      const [languages, setLanguages] = useState([]);
      const [editingAwardId, setEditingAwardId] = useState(null);
      const [editingBranchId, setEditingBranchId] = useState(null);
      const [showUpgradeModal, setShowUpgradeModal] = useState(false);
      const [availability, setAvailability] = useState([]);
        const [agePreferences, setAgePreferences] = useState(null);
      const [earnings, setEarnings] = useState(null);
      const [withdrawHistory, setWithdrawHistory] = useState([]);
      const [upgradeHistory, setUpgradeHistory] = useState([]);
      const [adsLoading, setAdsLoading] = useState(true);
      const [existingImage, setExistingImage] = useState("");
      const [editingBlogId, setEditingBlogId] = useState(null);
      const [awardErrors, setAwardErrors] = useState({
        title: "",
        image: "",
      });
      const [awards, setAwards] = useState([]);
      const [adsList, setAdsList] = useState(fallbackAds);
      const [showBlogModal, setShowBlogModal] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [branches, setBranches] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [showBranchModal, setShowBranchModal] = useState(false);
  const [existingAwardImage, setExistingAwardImage] = useState("");

  const [branchForm, setBranchForm] = useState({
    country: "",
    state: "",
    city: "",
    pincode: "",
    area: "",
    location: "",
    address_line1: "",
    address_line2: ""
  });

const fetchPlan = async () => {
  if (!tutor?.user_id) return;

  setPlanLoading(true); // 🔥 start loading

  const res = await fetch(
    `https://kalakakshaaha.com/kks/api/v1/get-plan?tutor_id=${tutor.user_id}`
  );

  const data = await res.json();

  setPlanStatus(data.plan === "premium" ? "premium" : "free");

  setPlanLoading(false); // 🔥 stop loading
};

  const fetchBranches = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const res = await fetch(
        "https://kalakakshaaha.com/kks/api/v1/tutor-branches",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();

      if (data.success) {
        setBranches(data.data || []);
      }
    } catch (err) {
      console.error("Failed to fetch branches", err);
    }
  };

  const fetchUpgradeHistory = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!tutor?.user_id) return;

    const res = await fetch(
      `https://kalakakshaaha.com/kks/api/v1/tutor/upgrade-history?tutor_id=${tutor.user_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await res.json();
    if (data.success) {
      setUpgradeHistory(data.data || []);
    }
  } catch (err) {
    console.error("Upgrade history fetch error:", err);
  }
};
  
const fetchWithdrawHistory = async () => {
  try {
    const token = localStorage.getItem("token");

    if (!tutor?.user_id) return;

    const res = await fetch(
      `https://kalakakshaaha.com/kks/api/v1/tutor/withdraw-history?tutor_id=${tutor.user_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await res.json();

    console.log("Withdraw API Response:", data);

    if (data.success) {
      setWithdrawHistory(data.data);
    }

  } catch (err) {
    console.error("Fetch Error:", err);
  }
};
  
const [planStatus, setPlanStatus] = useState("");
const [planLoading, setPlanLoading] = useState(true);
  const handleEditBlog = (blog) => {

    setBlogTitle(blog.title || "");
    setBlogShort(blog.short_description || "");
    setBlogFull(blog.full_content || "");

    // Fix date format
    const formattedDate = blog.published_date
      ? blog.published_date.split("T")[0]
      : "";

    setPublishedDate(formattedDate);

    setExistingImage(blog.image || "");

    setEditingBlogId(blog.id);
    setShowBlogModal(true);
  };

  const handleDeleteBlog = async (id) => {

    const confirm = await Swal.fire({
      title: "Delete blog?",
      text: "This cannot be undone",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ff7a00"
    });

    if (!confirm.isConfirmed) return;

    const res = await fetch(
      `https://kalakakshaaha.com/kks/api/v1/tutor/blogs/${id}`,
      { method: "DELETE" }
    );

    const data = await res.json();

    if (data.success) {
      fetchBlogs(tutor.id);
    }
  };

  const handleEditAward = (award) => {
    setAwardTitle(award.title || "");
    setAwardLink(award.award_link || "");
    setExistingAwardImage(award.image_url || "");

    setAwardImage(null); // reset file input

    setEditingAwardId(award.id); // important for edit mode
    setShowAwardModal(true);
  };

  const handleDeleteAward = async (id) => {

    const confirm = await Swal.fire({
      title: "Delete award?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ff7a00"
    });

    if (!confirm.isConfirmed) return;

    const token = localStorage.getItem("token");

    await fetch(
      `https://kalakakshaaha.com/kks/api/v1/tutor/award/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    fetchAwards();
  };
  const saveBranch = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        alert("Please login again");
        return;
      }

      if (!branchForm.city || !branchForm.address_line1) {
        alert("City and Address Line 1 are required");
        return;
      }

      const isEdit = editingBranchId !== null;

      const url = isEdit
        ? `https://kalakakshaaha.com/kks/api/v1/tutor-branches/${editingBranchId}`
        : `https://kalakakshaaha.com/kks/api/v1/tutor-branches`;

      const method = isEdit ? "PUT" : "POST";

      /* -------- FIND CITY -------- */

      const existingCity = cities.find(
        (c) =>
          c.city_name.toLowerCase() === branchForm.city.toLowerCase() &&
          String(c.state_id) === String(branchForm.state)
      );

      let cityId;

      if (existingCity) {
        cityId = existingCity.id;
      } else {
        /* -------- CREATE NEW CITY -------- */

        const cityRes = await fetch(
          "https://kalakakshaaha.com/kks/api/v1/cities",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              city_name: branchForm.city,
              state_id: branchForm.state,
              country_id: branchForm.country,
            }),
          }
        );

        const cityData = await cityRes.json();

        if (!cityData.success) {
          alert("Failed to create city");
          return;
        }

    cityId =
    cityData?.data?.id ||
    cityData?.city_id ||
    cityData?.id;

  if (!cityId) {
    console.error("City API response:", cityData);
    alert("City creation failed");
    return;
  }

        /* update local cities list */
        setCities((prev) => [...prev, cityData.data]);
      }

      /* -------- SAVE BRANCH -------- */

      const res = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...branchForm,
          city: cityId, // 🔥 store city_id instead of name
        }),
      });

      const data = await res.json();

      if (data.success) {
        alert(
          isEdit
            ? "Branch updated successfully ✅"
            : "Branch added successfully ✅"
        );

        fetchBranches();

        setShowBranchModal(false);

        setBranchForm({
          country: "",
          state: "",
          city: "",
          pincode: "",
          area: "",
          location: "",
          address_line1: "",
          address_line2: "",
        });

        setEditingBranchId(null);
      } else {
        alert(data.message || "Failed to save branch");
      }
    } catch (err) {
      console.error("Branch save error:", err);
      alert("Something went wrong");
    }
  };
  const saveAward = async () => {

    const token = localStorage.getItem("token");

    const isEdit = editingAwardId !== null;

    const formData = new FormData();
    formData.append("title", awardTitle);
    formData.append("award_link", awardLink);

    if (awardImage) {
      formData.append("image", awardImage);
    }

    if (isEdit) {
      formData.append("id", editingAwardId);
    }

    const url = isEdit
      ? "https://kalakakshaaha.com/kks/api/v1/tutor/award/update"
      : "https://kalakakshaaha.com/kks/api/v1/tutor/award";

    try {

      const res = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData
      });

      const data = await res.json();

      if (data.success) {

        alert(isEdit
          ? "Award updated successfully ✅"
          : "Award added successfully ✅"
        );

        // reset form
        setAwardTitle("");
        setAwardLink("");
        setAwardImage(null);

        setEditingAwardId(null);
        setShowAwardModal(false);

        fetchAwards();

      } else {
        alert(data.message || "Failed to save award");
      }

    } catch (err) {
      console.error("Award error:", err);
      alert("Something went wrong");
    }
  };

  const [canSwitchProfile, setCanSwitchProfile] = useState(false);

  const [blogTitle, setBlogTitle] = useState("");
  const [blogAuthor, setBlogAuthor] = useState("");
  const [blogShort, setBlogShort] = useState("");
  const [blogFull, setBlogFull] = useState("");
  const [blogImage, setBlogImage] = useState(null);
  const [publishedDate, setPublishedDate] = useState("");
  const [activeTab, setActiveTab] = useState("requests"); 
  const [blogErrors, setBlogErrors] = useState({});
  const [completedSessions, setCompletedSessions] = useState([]);

  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showImagePreview, setShowImagePreview] = useState(false);
const [requestPrices, setRequestPrices] = useState({});


  const openDetails = (req) => {
    
    setSelectedRequest(req);
  };

  const closeDetails = () => {
    setSelectedRequest(null);
  };


  const [expandedRequestId, setExpandedRequestId] = useState(null);

  const toggleDetails = (id) => {
    setExpandedRequestId(prev => (prev === id ? null : id));
  };


  const switchProfile = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(
        "https://kalakakshaaha.com/kks/api/v1/switch-profile",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const data = await res.json();

      if (!data.success) {
        Swal.fire("No other profile found");
        return;
      }

      // Save new JWT
      localStorage.setItem("token", data.token);

      Swal.fire({
        icon: "success",
        title: "Profile switched",
        showConfirmButton: false,
        timer: 1200,
        didClose: () => {
          if (data.role === "student") {
            navigate("/student-profile");
          } else {
            navigate("/tutor-profile");
          }
        }
      });

    } catch (err) {
      Swal.fire("Switch failed");
    }
  };
  const checkSwitchProfile = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(
        "https://kalakakshaaha.com/kks/api/v1/switch-profile",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const data = await res.json();

      if (data.success) {
        setCanSwitchProfile(true);   // has other profile
      } else {
        setCanSwitchProfile(false);  // no other profile
      }
    } catch {
      setCanSwitchProfile(false);
    }
  };


      const gradientBgStyle = {
        backgroundColor: "#ffd58a",
        backgroundImage:
          "linear-gradient(135deg, #ffb7d2, #ffd58a, #b6e9ff)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      };

      // --------------------
      // HELPER FUNCTIONS
      // --------------------
        
      const getModeOfClass = (tutor) => {
      if (!tutor) return null;

      const modes = [];

      if (Number(tutor.is_online) === 1) modes.push("Online");
      if (Number(tutor.is_offline) === 1) modes.push("Offline");
      if (Number(tutor.is_home_tuition) === 1) modes.push("Home Visit");

      return modes.length > 0 ? modes.join(", ") : null;
    };

    



      const hasValue = (val) => {
      if (Array.isArray(val)) return val.length > 0;
      if (typeof val === "object" && val !== null)
        return Object.values(val).some(v => v === 1 || v === true);
      return val !== null && val !== undefined && String(val).trim() !== "";
    };




      const getCurrencySymbol = () => {
    if (!tutor || !tutor.country_id) return "₹";

    const country = countries.find(
      c => String(c.id) === String(tutor.country_id)
    );

    return country?.currency_symbol || "₹";
  };



      const dayNames = {
      1: "Mon",
      2: "Tue",
      3: "Wed",
      4: "Thu",
      5: "Fri",
      6: "Sat",
      7: "Sun"
    };

      const getCityName = (id) => {
        const city = cities.find(c => c.id === Number(id));
        return city ? city.city_name : "";
      };

      const getStateName = (id) => {
        const state = states.find(s => s.id === Number(id));
        return state ? state.state_name : "";
      };

      const getCountryName = (id) => {
        const country = countries.find(c => c.id === Number(id));
        return country ? country.country_name : "";
      };

    const fetchAwards = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await fetch(
          "https://kalakakshaaha.com/kks/api/v1/awards",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();

        if (data.success) {
          setAwards(data.awards || []);
        }
      } catch (err) {
        console.error("Failed to fetch awards", err);
      }
    };
  const handleEditBranch = (branch) => {
    setBranchForm({
      ...branch,
      city: getCityName(branch.city)
    });
    setEditingBranchId(branch.id);
    setShowBranchModal(true);
  };

  const handleDeleteBranch = async (id) => {

    if (!window.confirm("Delete this location?")) return;

    const token = localStorage.getItem("token");

    await fetch(
      `https://kalakakshaaha.com/kks/api/v1/tutor-branches/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    fetchBranches();
  };

  const fetchBlogs = async (tutorId) => {
    if (!tutorId) return;

    const res = await fetch(
      `https://kalakakshaaha.com/kks/api/v1/tutor/blogs/${tutorId}`
    );
    const data = await res.json();
    if (data.success) setBlogs(data.blogs);
  };

  const updateRequestStatus = async (id, status, price = null) => {
    const token = localStorage.getItem("token");

    const res = await fetch(
      `https://kalakakshaaha.com/kks/api/v1/tutor/demo-requests/${id}/status`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          status,
          price
        }),
      }
    );

    const data = await res.json();

    if (data.success) {
      Swal.fire("Success", data.message, "success");

      setRequests((prev) =>
        prev.map((r) =>
          r.id === id ? { ...r, status, price } : r
        )
      );
    } else {
      Swal.fire("Error", data.message || "Failed", "error");
    }
  };




      



      

    const getAwardImage = (award) => {
      if (!award?.image_url) return null;
      return `https://kalakakshaaha.com/uploads/awards/${award.image_url}`;
    };



        useEffect(() => {
            fetchPlan();
          }, [tutor]);

        useEffect(() => {
          fetchWithdrawHistory();
        }, []);
        useEffect(() => {
          if (activeTab === "earnings") {
            fetchWithdrawHistory();
          }
          if (activeTab === "payments") {
            fetchUpgradeHistory();
          }
        }, [activeTab, tutor]);


      useEffect(() => {
        if (showAwardModal) {
          document.documentElement.style.overflow = "hidden";
          document.body.style.overflow = "hidden";
        } else {
          document.documentElement.style.overflow = "";
          document.body.style.overflow = "";
        }

        return () => {
          document.documentElement.style.overflow = "";
          document.body.style.overflow = "";
        };
      }, [showAwardModal]);

  useEffect(() => {
    if (activeTab === "completed" && tutor?.user_id) {
      fetchCompletedSessions();
    }
  }, [activeTab, tutor]);


const fetchCompletedSessions = async () => {
  try {
    const res = await fetch(
      `https://kalakakshaaha.com/kks/api/v1/tutor/activity/${tutor.user_id}`
    );

    const data = await res.json();



    if (data.status) {
      setCompletedSessions(data.data || []);
    }
  } catch (err) {
    console.error("Failed to fetch tutor activity", err);
  }
};

 const handleWithdraw = async () => {

  Swal.fire({
    title: "Withdraw Amount",
    input: "number",
    inputLabel: `Available Balance: ₹${earnings?.balance || 0}`,
    inputPlaceholder: "Enter amount",
    showCancelButton: true,
    confirmButtonText: "Request Withdraw",

    preConfirm: (value) => {

      const amount = Number(value);
      const balance = Number(earnings?.balance || 0);

      if (!amount || amount <= 0) {
        Swal.showValidationMessage("Enter a valid amount");
        return false;
      }

      if (amount > balance) {
        Swal.showValidationMessage("Amount exceeds balance");
        return false;
      }

      return amount;
    }

  }).then(async (result) => {

    if (!result.isConfirmed) return;

    const amount = result.value;

    try {

      const res = await fetch(
        "https://kalakakshaaha.com/kks/api/v1/tutor/withdraw",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            tutor_id: tutor.user_id,
            amount: amount
          })
        }
      );

      const data = await res.json();

      if (data.success) {

        Swal.fire({
          icon: "success",
          title: "Request Sent",
          text: "Your withdraw request has been sent to admin for approval"
        });

        // Refresh wallet
        const earningsRes = await fetch(
          `https://kalakakshaaha.com/kks/api/v1/tutor/earnings/${tutor.user_id}`
        );

        const earningsData = await earningsRes.json();

        if (earningsData.success) {
          setEarnings(earningsData.earnings);
        }

      } else {

        Swal.fire({
          icon: "warning",
          title: "Withdraw Request",
          text: data.message
        });

      }

    } catch (err) {

      console.error("Withdraw error:", err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong"
      });

    }

  });

};



    const addAwardApi = async () => {
      let errors = {};

      if (!awardTitle.trim()) {
        errors.title = "Title is required";
      }

      if (!awardImage) {
        errors.image = "Image is required";
      }

      if (Object.keys(errors).length > 0) {
        setAwardErrors(errors);
        return;
      }

      setAwardErrors({ title: "", image: "" });

      const token = localStorage.getItem("token");
      if (!token) {
        alert("Please login again");
        navigate("/login");
        return;
      }
    const isEdit = editingAwardId !== null;
      const formData = new FormData();
      formData.append("title", awardTitle);
      formData.append("award_link", awardLink || "");

      if (awardImage) {
        formData.append("image", awardImage);
      }

      try {
        const res = await fetch(
          "https://kalakakshaaha.com/kks/api/v1/tutor/award",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`, // ✅ REQUIRED
            },
            body: formData, // ✅ multipart
          }
        );

        const data = await res.json();

        if (data.success) {
            alert(isEdit ? "Award updated successfully ✅" : "Award added successfully ✅");

          setAwardTitle("");
          setAwardLink("");
          setAwardImage(null);
          setAwardErrors({ title: "", image: "" });

          setEditingAwardId(null);

          setShowAwardModal(false);
          fetchAwards(tutor.id);
        } else {
          alert(data.message || "Failed to add award");
        }
      } catch (error) {
        console.error(error);
        alert("Something went wrong. Please try again.");
      }
    };


  const addBlogApi = async () => {

    let errors = {};

    if (!blogTitle) errors.title = "Title required";
    if (!blogShort) errors.short = "Short description required";
    if (!blogFull) errors.full = "Content required";

    if (Object.keys(errors).length) {
      setBlogErrors(errors);
      return;
    }

    const formData = new FormData();

    formData.append("title", blogTitle);
    formData.append("author", tutor.full_name || tutor.owner_name);
    formData.append("published_date", publishedDate || new Date().toISOString().slice(0,10));
    formData.append("short_description", blogShort);
    formData.append("full_content", blogFull);
    formData.append("tutor_id", tutor.id);

    if (blogImage) {
      formData.append("image", blogImage);
    }

    const url = editingBlogId
      ? `https://kalakakshaaha.com/kks/api/v1/blogs/${editingBlogId}`
      : `https://kalakakshaaha.com/kks/api/v1/blogs`;

    const method = editingBlogId ? "POST" : "POST";

    const res = await fetch(url, {
      method,
      body: formData
    });

    const data = await res.json();

    if (data.success) {

      await Swal.fire({
        icon: "success",
        title: editingBlogId ? "Blog Updated" : "Blog Submitted",
        text: editingBlogId
          ? "Your blog was updated successfully"
          : "Your blog is sent for admin approval",
        confirmButtonColor: "#ff7a00",
      });

      setShowBlogModal(false);

      // reset editing state
      setEditingBlogId(null);

      // reset form
      setBlogTitle("");
      setBlogShort("");
      setBlogFull("");
      setBlogImage(null);

      fetchBlogs(tutor.id);
    }
  };
  
  useEffect(() => {
    if (tutor?.id) {
      fetchBlogs(tutor.id);
    }
  }, [tutor?.id]);

  useEffect(() => {
    if (!tutor || !tutor.id) return;   // 🔒 guard

    fetch(`https://kalakakshaaha.com/kks/api/v1/tutor/earnings/${tutor.user_id}`)

      .then(res => res.json())
      .then(data => {
      
        if (data.success) setEarnings(data.earnings);
      })
      .catch(err => console.error("Earnings fetch error:", err));
  }, [tutor]);


      useEffect(() => {
        if (!tutor?.category_id) {
          setAdsList(fallbackAds);
          return;
        }

        fetch(
          `https://kalakakshaaha.com/kks/api/v1/ads_api.php?category=${tutor.category_id}`
        )
          .then((res) => {
            const contentType = res.headers.get("content-type");
            if (!contentType || !contentType.includes("application/json")) {
              throw new Error("Ads API did not return JSON");
            }
            return res.json();
          })
          .then((data) => {
            if (data.success && data.ads && data.ads.length > 0) {
              setAdsList(data.ads);
            } else {
              setAdsList(fallbackAds);
            }
          })
          .catch((err) => {
            console.error("Ads fetch failed:", err);
            setAdsList(fallbackAds);
          });
      }, [tutor?.category_id]);

      useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }

        

    fetch("https://kalakakshaaha.com/kks/api/tutor/profile", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setTutor(data.profile);
          fetchBranches();
          checkSwitchProfile();


          // ✅ IMPORTANT FIX
          setAvailability(data.profile.availability || []);
          setAgePreferences(data.profile.age_preferences || null);

          fetchAwards(data.profile.id);
          fetchBlogs(data.profile.id);

        }
      });

  fetch("https://kalakakshaaha.com/kks/api/v1/tutor-demo-requests", { 
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(res => res.json())
    .then(data => {
      //console.log("REQUEST API RESPONSE 👉", data); //  ADD THIS
      if (data.success) {
        //console.log("REQUESTS ARRAY 👉", data.requests); // FF ADD THIS
        setRequests(data.requests);
      }
    });


        fetch("https://kalakakshaaha.com/kks/api/v1/categories")
          .then(res => res.json())
          .then(data => data.success && setCategories(data.categories));

        fetch("https://kalakakshaaha.com/kks/api/v1/cities")
          .then(res => res.json())
          .then(data => data.success && setCities(data.cities));

        fetch("https://kalakakshaaha.com/kks/api/v1/states")
          .then(res => res.json())
          .then(data => data.success && setStates(data.states));

        fetch("https://kalakakshaaha.com/kks/api/v1/countries")
          .then(res => res.json())
          .then(data => data.success && setCountries(data.countries));

      }, [navigate]);


      
      return (
        <Fragment>
          <Header />
      
          <section className="instructor-single-section padding-tb section-bg">
            <div className="container" style={{ marginTop: "100px" }}>
              
              <div className="row">
                {/* PROFILE + CONTENT */}
                <div className="col-12 col-lg-12">
                  <div className="row align-items-stretch">
                    

                    {/* PROFILE CARD */}
                    <div className="col-12 col-lg-3 mb-4 d-flex align-items-stretch">



                      {!tutor ? (
                        <ProfileSkeleton />
                      ) : (
                        <div className="fun-card profile-card resume-profile w-100">
                          {/* TOP */}
                          <div className="resume-top text-center">
                            <div className="upgrade-container mb-3">
  {canSwitchProfile && (
    <button
      className="switch-profile-btn"
      onClick={switchProfile}
    >
      Switch to Student
    </button>
  )}

{planLoading ? (
  <button className="btn btn-secondary w-60 rounded-5" disabled>
    Checking...
  </button>
) : planStatus === "premium" ? (
  <button className="btn btn-warning w-60 rounded-5" disabled>
    Premium
  </button>
) : (
  <button
    className="btn btn-primary w-60 rounded-5"
    onClick={() => setShowUpgradeModal(true)}
  >
    Upgrade
  </button>
)}
                                    </div>
                                                      <div className="profile-avatar-wrapper">
                                                        {tutor.profile_photo ? (
                                                        <img
                              src={`https://kalakakshaaha.com/uploads/tutors/${tutor.profile_photo}`}
                              className="profile-avatar-large clickable-avatar"
                              alt="Tutor"
                              onClick={() => setShowImagePreview(true)}
                            />

                              ) : (
                                <div className="profile-avatar-placeholder">
                                  <span className="no-profile-text">No Profile Image</span>
                                </div>
                              )}
                            </div>
  {(tutor.full_name || tutor.owner_name) && (
    <div className="name-with-edit text-center">

      {/* TUTOR / INSTITUTE NAME */}
      <h2 className="profile-name mb-0">
        {tutor.full_name || tutor.institute_name}
      </h2>

      {/* OWNER NAME (only for institutes) */}
      {tutor.tutor_type === "institute" && tutor.institute_name && (
        <h4 className="profile-sub mb-0">
          ({tutor.institute_name})
        </h4>
      )}

      <div>
        <i
          className="fas fa-edit edit-icon"
          title="Edit Profile"
          onClick={() => navigate("/tutor/edit-profile")}
        ></i>
        <div className="edit-tooltip"      onClick={() => navigate("/tutor/edit-profile")}>Edit Profile</div>
      </div>
    </div>
  )}





                            

                        {/*} {tutor.category && (
      <p className="profile-sub">
        {tutor.category}
      </p>
    )}*/}



                                {(tutor.website || tutor.instagram || tutor.youtube || tutor.facebook) && (
                            <div className="resume-section">
                          
                            
                              <div className="social-row" >


                                  {tutor.website && (
                                <div >
                                
                                  <a href={tutor.website} target="_blank" rel="noopener noreferrer">
                                  <i className="fas fa-globe" style={{color:"black"}}></i>
                                  </a>
                                </div>
                              )}
                              
                                {tutor.facebook && (
                                  <a href={tutor.facebook} target="_blank" rel="noopener noreferrer" title="Facebook">
                                    <i className="fab fa-facebook-f"></i>
                                  </a>
                                )}
                                {tutor.instagram && (
                                  <a href={tutor.instagram} target="_blank" rel="noopener noreferrer" title="Instagram">
                                    <i className="fab fa-instagram"></i>
                                  </a>
                                )}
                                {tutor.youtube && (
                                  <a href={tutor.youtube} target="_blank" rel="noopener noreferrer" title="YouTube">
                                    <i className="fab fa-youtube"></i>
                                  </a>
                                )}
                              </div>
                            </div>
                          )}
                          </div>



                        

                        

                            {/* PROFESSIONAL INFO */}
                          {(tutor.category_id || tutor.experience || tutor.membership_plan || tutor.skills) && (
                            <div className="resume-section">
                              <h6>CATEGORY</h6>
                            {tutor.category && (
      <div className="icon-row">
        <i className="fas fa-tag"></i>
        <span>{tutor.category}</span>
      </div>
    )}


              <h6>SUB CATEGORY</h6>
                  {tutor.skills_list && tutor.skills_list.length > 0 && (
      <div className="icon-row">
        <i className="fas fa-check-circle"></i>
        <div>
        <span>
          {tutor.skills_list.map(s => s.skill_title).join(", ")}
        </span>
        </div>
      </div>
    )}

      <h6>MODE OF CLASS</h6>
      {/* MODE OF CLASS */}
    {/* MODE OF CLASS */}
    {getModeOfClass(tutor) && (
      <div className="icon-row">
        <i className="fas fa-laptop-house"></i>
        <span>
          {getModeOfClass(tutor)} classes
        </span>
      </div>
    )}


      


      <h6>EXPERIENCE</h6>
                              {tutor.experience && (
                                <div className="icon-row">
                                  <i className="fas fa-briefcase"></i>
                                  <span>{tutor.experience} years experience</span>
                                </div>
                              )}
                              
  <h6>FEE PER SESSION</h6>

  {tutor.fee_min !== null && tutor.fee_max !== null && (
    <div className="icon-row">
      <i className="fas fa-money-bill"></i>
      <span>
      {getCurrencySymbol()} {Math.trunc(tutor.fee_min)} –   {getCurrencySymbol()} {Math.trunc(tutor.fee_max)} / session
      </span>
    </div>
  )}



    <h6>DEMO AVAILABILTY</h6>
      {typeof tutor.is_demo_available !== "undefined" && (
        <div className="icon-row">
          <i className="fas fa-chalkboard-teacher"></i>
          <span>
            Demo Class:{" "}
            {Number(tutor.is_demo_available) === 1 ? "Available" : "Not Available"}
          </span>
        </div>
      )}

      


      
    <h6>LANGUAGES</h6>
    {tutor.languages && tutor.languages.length > 0 && (
      <div className="icon-row">
        <i className="fas fa-language"></i>
        <span>
          {tutor.languages.map(l => l.language_name).join(", ")}
        </span>
      </div>
    )}

    {tutor.membership_plan &&
    !["Basic", "None", "free"].includes(
      tutor.membership_plan.toLowerCase()
    ) && (
      <div className="icon-row">
        <i className="fas fa-star"></i>
        <span>{tutor.membership_plan}</span>
      </div>
    )}



                            </div>
                          )}


                            



                      
  {/* LOCATION */}
  {(
    hasValue(tutor.address_line1) ||
    hasValue(tutor.address_line2) ||
    hasValue(tutor.area) ||
    hasValue(tutor.location) ||
    hasValue(tutor.city_id) ||
    hasValue(tutor.state_id) ||
    hasValue(tutor.country_id) ||
    hasValue(tutor.pincode)
  ) && (
    <div className="resume-section">
      <h6>LOCATION</h6>

      <div className="icon-row">
        <i className="fas fa-home"></i>
        <span>
          {[
            tutor.address_line1,
            tutor.address_line2,
            tutor.area,
            tutor.location,
            getCityName(tutor.city_id),
            getStateName(tutor.state_id),
            getCountryName(tutor.country_id),
          ]
            .filter(hasValue)
            .join(", ")}

          {hasValue(tutor.pincode) && ` PIN: ${tutor.pincode}`}
        </span>
      </div>
    </div>
  )}







                      

                          {/* AVAILABILITY & AGE GROUP */}
                          {(tutor.tutor_availability || tutor.age_group) && (
                            <div className="resume-section">
                              <h6>TEACHING</h6>
                              {hasValue(tutor.age_group) && (
          <div className="icon-row">
            <i className="fas fa-graduation-cap"></i>
            <span>{tutor.age_group}</span>
          </div>
        )}

        {hasValue(tutor.tutor_availability) && (
          <div className="icon-row">
            <i className="fas fa-clock"></i>
            <span>{tutor.tutor_availability}</span>
          </div>
        )}
                            </div>
                          )}

                          {/* ONLINE PRESENCE */}
                        

                      
                        </div>
                      )}
                    </div>

                    {/* RIGHT SIDE - REQUESTS & AWARDS */}
                    <div className="col-12 col-lg-6 d-flex flex-column">
                      <div style={{display:"flex", flexDirection:"column",gap:"20px"}}> 
  <div className="fun-card awards-card h-10 overview-containerr" style={gradientBgStyle}>

    {tutor?.bio && (
      <div className="resume-section">

        <h4>Overview</h4>

        <div className="bio-wrapper">

          <div className="bio-text-scrolll" style={{ textAlign: "justify" }}>

            <p>
              {(tutor?.bio ||
                "A dedicated and experienced tutor specializing in the art of Expressionism. I focus on developing unique personal styles and technical mastery across various mediums."
              ).replace(/<\/?(p|br)\s*\/?>/g, "")}
            </p>

          </div>

        </div>

      </div>
    )}

  </div>

  {/* REQUEST / EARNINGS / COMPLETED CARD */}
  <div className="fun-card request-container mb-4 " style={gradientBgStyle}>

    {/* HEADER SWITCH */}
    <div className="card-switch-header mb-3">
      <h4>
        {activeTab === "requests" && "Requests Received"}
         {activeTab === "earnings" && "My Earnings" }
        {activeTab === "completed" && "Likes and Views"}
      </h4>

      <div className="switch-group">
        <button
          className={activeTab === "requests" ? "switch-btn active" : "switch-btn"}
          onClick={() => setActiveTab("requests")}
        >
          Requests
        </button>
        
        {/*
        <button
          className={activeTab === "earnings" ? "switch-btn active" : "switch-btn"}
          onClick={() => setActiveTab("earnings")}
        >
        Earnings
        </button>*/}
    

        <button
          className={activeTab === "completed" ? "switch-btn active" : "switch-btn"}
          onClick={() => setActiveTab("completed")}
        >
        Likes and Views
        </button>

        <button
        className={activeTab === "payments" ? "switch-btn active" : "switch-btn"}
        onClick={() => setActiveTab("payments")}
      >
        Payments
      </button>

      </div>
    </div>

    {/* ---------------- REQUESTS TAB ---------------- */}
    {activeTab === "requests" && (
      <>
        {requests.length === 0 ? (
          <div className="request-table-wrapper">
          
          <h4 className="text-center my-5">No requests received yet.</h4>
        
          </div>
        ) : (
        <div className="request-table-wrapper">
    <div className="request-table">

  <div className="request-row request-header">
    <div>Student</div>
    <div>Date</div>
    <div>Status</div>
    <div>Price</div>
    <div>Action</div>
  </div>

  </div>
  {requests.map(req => (
    <Fragment key={req.id}>
      
      {/* Main Row */}
  <div className="request-row">

    <div>{req.student_name}</div>

    <div>{req.request_date}</div>
<div className={`status-text status-${req.status}`}>
  {req.status === 2
    ? "Rejected"
    : req.status === 1 && req.tutor_status == 1
      ? "Accepted"
      : req.status === 1 && req.tutor_status == 0
        ? " Needs Your Response"
        : "Pending Admin"}
</div>

    <div>
<input
  type="number"
  placeholder="price"
  value={requestPrices[req.id] ?? req.price ?? ""}
  disabled={req.tutor_status == 1}
  onChange={(e) =>
    setRequestPrices({
      ...requestPrices,
      [req.id]: e.target.value
    })
  }
  style={{ width: "83px" }}
/>
    </div>

<div style={{display:"flex", gap:"5px"}}>

{req.status === 1 && req.tutor_status == 0 && (
  <>
<button
  className="accept-btn"
  onClick={() => {

    const price = requestPrices[req.id] ?? req.price;

    if (!price || Number(price) <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Enter price",
        text: "Please enter a valid price before accepting"
      });
      return;
    }

    updateRequestStatus(req.id, 1, price);
  }}
>
  Accept
</button>

    <button
      className="reject-btn"
      onClick={() => updateRequestStatus(req.id, 2)}
    >
      Reject
    </button>
  </>
)}

{req.status === 1 && req.tutor_status == 1 && (
  <span className="paid-label">Accepted</span>
)}

{req.status === 2 && (
  <span className="rejected-label">Rejected</span>
)}

</div>
  {(req.category_names || req.skill_names) && (
    <div>
      <button
        className="details-btn"
        onClick={() => openDetails(req)}
      >
        More Details
      </button>
    </div>
  )}

      </div>

      {/* Expandable Row */}
    
  {showImagePreview && tutor?.profile_photo &&
    createPortal(
      <div
        className="image-preview-overlay"
        onClick={() => setShowImagePreview(false)}
      >
        <div
          className="image-preview-container"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="image-close-btn"
            onClick={() => setShowImagePreview(false)}
          >
            ✕
          </button>

          <img
            src={`https://kalakakshaaha.com/uploads/tutors/${tutor.profile_photo}`}
            className="image-preview-full"
            alt="Full Profile"
          />
        </div>
      </div>,
      document.body
    )
  }

    </Fragment>
  ))}



{selectedRequest &&
  createPortal(
    <div
      className="request-modal-overlay"
      onClick={closeDetails}
    >
      <div
        className="request-modal-body"
        onClick={(e) => e.stopPropagation()}
      >

        <button className="modal-close-btn" onClick={closeDetails}>
          ✕
        </button>
        <div className="request-modal-body">

          <div className="detail-row">
            <span className="label">Student</span>
            <span>{selectedRequest.student_name}</span>
          </div>

          <div className="detail-row">
            <span className="label">Date</span>
            <span>{selectedRequest.request_date}</span>
          </div>
          <div className="detail-row">
            <span className="label">Time</span>
            <span>
              {selectedRequest.request_time
                ? new Date(`1970-01-01T${selectedRequest.request_time}`)
                    .toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
                : "N/A"}
            </span>
          </div>
          <div className="detail-card">
            <span className="label">Phone</span>
            <span className="value">
              {selectedRequest.phone_code} {selectedRequest.phone}
            </span>
          </div>

          <div className="detail-block">
            <span className="label">Categories</span>
            <div className="tag-containerr">
              {selectedRequest.category_names?.split(",").map((c, i) => (
                <span key={i} className="tag">{c}</span>
              ))}
            </div>
          </div>
           
           <div className="detail-block">
  <span className="label">Requirement</span>
  <div className="requirement-text">
    {selectedRequest.requirement || "No requirement provided"}
  </div>
</div>
          <div className="detail-block">
            <span className="label">Sub Categories</span>
            <div className="tag-containerr">
              {selectedRequest.skill_names?.split(",").map((s, i) => (
                <span key={i} className="tag tag-skill">{s}</span>
              ))}
            </div>
          </div>

        </div>

      </div>
    </div>,
    document.body
  )}




          </div>
        )}
      </>
    )}

      {/* ---------------- EARNINGS TAB ---------------- */}
    {activeTab === "earnings" && (
      <>
      <div className="earnings-grid">

        <div className="earn-box">
          <p>Total Earned</p>
          <h3>{getCurrencySymbol()}{earnings?.total_earnings}
    </h3>
        </div>

        <div className="earn-box">
          <p>Wallet Balance</p>
          <h3>₹{earnings?.balance || 0}</h3>
        </div>

        <div className="earn-box">
          <p>Withdrawn</p>
          <h3>₹{earnings?.withdrawn || 0}</h3>
        </div>

        <div className="earn-box full">
          <div className="stats-row">
          
          </div>

              <button
                className="withdraw-btn"
                onClick={handleWithdraw}
                disabled={earnings?.withdraw_status === 1}
              >
                {earnings?.withdraw_status === 1 ? "Request Pending" : "Withdraw"}
              </button>
        </div>

      </div>
      
<div className="withdraw-history">
  <h4>Withdraw History</h4>

  {(!withdrawHistory || withdrawHistory.length === 0) ? (
    <p>No withdraw requests yet</p>
  ) : (
    <div className="bio-text-scrolll">
      <div className="withdraw-table">

        {/* HEADER */}
        <div className="withdraw-row withdraw-header">
          <div>ID</div>
          <div>Amount</div>
          <div>Status</div>
          <div>Date</div>
        </div>

        {/* DATA */}
        <div className="withdraw-body">
          {withdrawHistory.map((item) => (
            <div className="withdraw-row" key={item.id}>
              <div>#{item.id}</div>
              <div>₹{item.amount}</div>

              <div>
                <span className={`status-badge status-${item.withdraw_status}`}>
                  {item.withdraw_status === 0 && "Pending"}
                  {item.withdraw_status === 1 && "Approved"}  
                  {item.withdraw_status === 2 && "Rejected"}
                </span>
              </div>

              <div>{item.requested_at}</div>
            </div>
          ))}
        </div>

      </div>
    </div>
  )}
</div>
</>
      
    )}

{/* ---------------- PAYMENTS TAB ---------------- */}
{activeTab === "payments" && (
  <div className="withdraw-history">
    <h4>Upgrade Payment History</h4>

    {(!upgradeHistory || upgradeHistory.length === 0) ? (
      <p>No payment history yet</p>
    ) : (
      <div className="upgrade-text-scrolll">
        <div className="withdraw-table">

          {/* HEADER */}
          <div className="withdraw-row withdraw-header">
            <div>ID</div>
            <div>Plan</div>
            <div>Amount</div>
            <div>Payment ID</div>
            <div>Start</div>
            <div>End</div>
            <div>Status</div>
          </div>

          {/* ROWS */}
          <div className="withdraw-body">
            {upgradeHistory.map((item) => (
              <div className="withdraw-row" key={item.id}>
                <div>#{item.id}</div>
                <div>{item.plan_name}</div>
                <div>₹{item.amount}</div>
                <div style={{ fontSize: "11px" }}>{item.payment_id || "—"}</div>
                <div>{item.start_date?.split("T")[0] || item.start_date}</div>
                <div>{item.end_date?.split("T")[0] || item.end_date}</div>
                <div>
                  <span className={`status-badge status-${item.status}`}>
                    {item.status == 1 ? "Active" : "Expired"}
                  </span>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    )}
  </div>
)}
    {/* ---------------- COMPLETED TAB ---------------- */}
{activeTab === "completed" && (
  <div className="request-table-wrapper">

    <div className="request-row request-header">
      <div>Student</div>
      <div>Activity</div>
      <div>Date</div>
    </div>
{completedSessions.map((s, index) => (
  <div className="request-row" key={index}>

    <div>{s.student_name}</div>

    <div>
      {s.type === "like"
        ? "👍 Liked your profile"
        : `💬 ${s.comment_text}`}
    </div>

    <div>
      {new Date(s.date).toLocaleDateString()}
    </div>

  </div>
))}

  </div>
)}


</div>


  </div>


              <div style={{display:"flex", flexDirection:"column",gap:"20px"}}>
                    <div className="fun-card awards-card h-10 request-containerr" style={gradientBgStyle}>
                    <div className="awards-header d-flex justify-content-between">
                      <h4>My Blogs</h4>
                  <button
                    className="add-award-btn"
                    onClick={() => {
                      setEditingBlogId(null);
                      setBlogTitle("");
                      setBlogShort("");
                      setBlogFull("");
                      setBlogImage(null);
                      setExistingImage("");
                      setPublishedDate("");
                      setShowBlogModal(true);
                    }}
                  >
                        <i className="fas fa-plus"></i><span>Add Blog</span>
                      </button>
                    </div>


                    

                  <div
                    className="blogs-scroll"
                    onWheel={(e) => {
                      e.currentTarget.scrollLeft += e.deltaY;
                    }}
                  >

                      {blogs.length === 0 ? <p style={{marginLeft:230}}>No blogs added</p> : (
                            blogs.map(blog => (
                              <div className="blog-card" key={blog.id}>

                              

                                {blog.image && (
                                  <img
                                    src={`https://kalakakshaaha.com/uploads/blogs/${blog.image}`}
                                    className="award-image"
                                  />
                                )}

                                

                                <p className="award-title">{blog.title}</p>

                                <small>
                                  {blog.status === 1 ? "Approved" : "Pending"}
                                </small>
                                <div className="blog-actions ">
                                  <button class="btn btn">
                                  <i
                                    className="fas fa-edit"
                                     title="Edit Blog"
                                    onClick={() => handleEditBlog(blog)}
                                  ></i>
                                  <h3></h3>
                                  </button>
                                  <button class="btn btn">
                                  <i
                                    className="fas fa-trash"
                                     title="Delete Blog"
                                    onClick={() => handleDeleteBlog(blog.id)}
                                  ></i>
                                  </button>
                                </div>
                              </div>
                            ))
                      )}
                    </div>
                  </div>


                            <div className="fun-card awards-card h-10 branch-containerr" style={gradientBgStyle}>
                                                  
                                              <div className="awards-header d-flex justify-content-between">
                              <h4>Branches / Locations</h4>

                              <button
                                className="add-award-btn"
                           
                                onClick={() => setShowBranchModal(true)}
                              >
                                <i className="fas fa-plus"></i>
                                <span>Add Location</span>
                              </button>


                              
                            </div>
                            {/* BRANCH LOCATIONS */}
                          {branches.length > 0 && (
                            <div className="resume-sectionn">
                            

                          <div className="branches-scroll">
    {branches.map((branch) => (
      <div className="branch-row" key={branch.id}>

        <div className="branch-address">
          <i className="fas fa-map-marker-alt"></i>

          <span>
            {[
              branch.address_line1,
              branch.address_line2,
              branch.area,
              branch.location,
              getCityName(branch.city),
              getStateName(branch.state),
              getCountryName(branch.country),
            ]
              .filter(Boolean)
              .join(", ")}

            {branch.pincode && ` PIN: ${branch.pincode}`}
          </span>
        </div>

        <div 
        className="branch-actions"
          title="Edit Branch"
          >
          <button onClick={() => handleEditBranch(branch)}>
            <i className="fas fa-edit"></i>
          </button>
    </div>
    
        <div 
        className="branch-actions"
          title="Delete Branch"
          >
          <button onClick={() => handleDeleteBranch(branch.id)}>
            <i className="fas fa-trash"></i>
          </button>
        </div>

      </div>
    ))}
  </div>
                            </div>
                          )}
                            
                                            </div>

              </div>



                    </div>


                    
                    

                      
    <div className="col-12 col-lg-3 mb-4 d-flex align-items-stretch">
      {!tutor ? (
        <SideColumnSkeleton />
      ) : (
        <div className="d-flex flex-column gap-3 w-100">


        {/* PERSONAL INFO CARD */}
        <div className="fun-card awards-card h-100" style={gradientBgStyle}>


          {(tutor.full_name || tutor.gender || tutor.phone || tutor.email) && (
            <div className="resume-section">
              <h6>PERSONAL INFO</h6>
              {tutor.phone && (
                <div className="icon-row">
                  <i className="fas fa-phone"></i>
                  <span>{tutor.phone_code} {tutor.phone}</span>
                </div>
              )}
              {tutor.email && (
                <div className="icon-row">
                  <i className="fas fa-envelope"></i>
                  <span>{tutor.email}</span>
                </div>
              )}
              {tutor.gender && (
                <div className="icon-row">
                  <i className="fas fa-user"></i>
                  <span>{tutor.gender}</span>
                </div>
              )}
            </div>
          )}


                                  {/* AVAILABILITY & AGE GROUP */}
    {/* TEACHING AGE GROUP */}
    {agePreferences && 
      (agePreferences.under_10 || 
      agePreferences.age_10_to_15 || 
      agePreferences.age_16_to_25 || 
      agePreferences.above_25) ? (
        <div className="resume-section">
          <h6>TEACHING AGE GROUP</h6>
          <div className="icon-row">
            <i className="fas fa-graduation-cap"></i>
            <span>
              {[
                agePreferences.under_10 && "Under 10",
                agePreferences.age_10_to_15 && "10-15",
                agePreferences.age_16_to_25 && "16-25",
                agePreferences.above_25 && "Above 25"
              ]
                .filter(Boolean)
                .join(", ")}
            </span>
          </div>
        </div>
    ) : null}
                          

    {(() => {
      // Filter only active time slots
      const activeSlots = availability.filter(slot => slot.is_active);
      
      // Only show section if there are active slots
      if (!activeSlots || activeSlots.length === 0) {
        return null;
      }

      return (
        <div className="resume-section">
          <h6>AVAILABLE TIME SLOTS:</h6>
          <div className="availability-section">
            {activeSlots.map((slot, idx) => (
              <div className="icon-row" key={idx}>
                <i className="fas fa-clock"></i>
                <span>
                  {slot.day_id && `${dayNames[slot.day_id] || 'Day ' + slot.day_id}: `}
                  {slot.start_time} - {slot.end_time}
                </span>
              </div>
            ))}
          </div>
        </div>
      );
    })()}



        </div>

        {/* AWARDS & RECOGNITION CARD */}
        <div className="fun-card awards-card h-100" style={gradientBgStyle}>
          <div className="awards-header d-flex justify-content-between">
            <h4>Recognitions & Awards</h4>
            <button className="add-award-btn"   onClick={() => {
      setEditingAwardId(null);     // switch to add mode
      setAwardTitle("");           // clear title
      setAwardLink("");            // clear link
      setAwardImage(null);         // clear new image
      setExistingAwardImage("");   // clear old image
      setAwardErrors({ title: "", image: "" });

      setShowAwardModal(true);
    }}>
              <i className="fas fa-plus"></i>
              <span>Add Awards</span>
            </button>
          </div>

    <div className="award-text-scrolll">
      {awards.length === 0 ? (
        <p>No awards added</p>
      ) : (
        awards.map((award) => (
          <div className="award-card" key={award.id}>

            

            {award.image_url && (
              <img
                src={`https://kalakakshaaha.com/uploads/awards/${award.image_url}`}
                alt={award.title}
                className="award-image"
              />
              
            )}
                             <div style={{display : "flex" }}>
                                <div className="award-actions"
                      title="Edit Award">
                    <button class="btn btn">
                              <i
                                className="fas fa-edit"
                                onClick={() => handleEditAward(award)}
                              ></i>

                        
                              
                            </button>
                            
                                </div>
                                   <div className="award-actions"
                                                title=" Delete Award">
                                          <button class="btn btn">
                                        <i
                                          className="fas fa-trash"
                                          
                                          onClick={() => handleDeleteAward(award.id)}
                                        ></i>
                                        </button>
                                      </div>
                                      </div>

            

            <p className="award-title">{award.title}</p>
              
          </div>
        ))
      )}
    </div>





          
        </div> 







      </div>
    )}
    </div>



                  </div>
                </div>
              </div>

              {/* AWARD MODAL */}
  {showAwardModal &&
    createPortal(
    <div className="custom-modal-overlay">
      <div className="custom-award-modal">
        
        <div className="custom-modal-header">
            <h5>{editingAwardId ? "Edit Award / Recognition" : "Add Award / Recognition"}</h5>
          <button
            className="custom-close-btn"
            onClick={() => setShowAwardModal(false)}
          >
            ✕
          </button>
        </div>

        <div className="custom-modal-body">

          <div className="custom-form-group">
            <label>
              Title <span className="required-star">*</span>
            </label>
            <input
              type="text"
              placeholder="Award title"
              className="custom-input"
              value={awardTitle}
              onChange={(e) => {
                setAwardTitle(e.target.value);
                setAwardErrors({ ...awardErrors, title: "" });
              }}
            />
            {awardErrors.title && (
              <span className="custom-error">
                {awardErrors.title}
              </span>
            )}
          </div>

          <div className="custom-form-group">
            <label>Link</label>
            <input
              type="url"
              placeholder="https://example.com"
              className="custom-input"
              value={awardLink}
              onChange={(e) => setAwardLink(e.target.value)}
            />
          </div>

          <div className="custom-form-group">
            <label>
              Upload <span className="required-star">*</span>
            </label>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>

    <label className="choose-image-btn">
      Choose Image
      <input
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          setAwardImage(file);
          setExistingAwardImage(URL.createObjectURL(file));
          setAwardErrors({ ...awardErrors, image: "" });
        }}
      />
    </label>

    {existingAwardImage && (
      <img
        src={
          awardImage
            ? existingAwardImage
            : `https://kalakakshaaha.com/uploads/awards/${existingAwardImage}`
        }
        alt="Award"
        style={{ width: "120px", borderRadius: "6px" }}
      />
    )}

  </div>
            {awardErrors.image && (
              <span className="custom-error">
                {awardErrors.image}
              </span>
            )}
          </div>

        </div>

        <div className="custom-modal-footer">
          <button className="custom-primary-btn" onClick={addAwardApi}>
            Save
          </button>

          <button
            className="custom-secondary-btn"
          onClick={() => {
    setShowAwardModal(false);
    setAwardTitle("");
    setAwardLink("");
    setAwardImage(null);
    setExistingAwardImage("");
    setEditingAwardId(null);
  }}
          >
            Cancel
          </button>
        </div>

      </div>
    </div>,
    document.body   
    )}



  {showBlogModal && (
    <div className="modal-backdropp">
      <div className="fun-card award-modal" style={gradientBgStyle}>
        <div className="award-modal-header">
          <h5>{editingBlogId ? "Edit Blog" : "Add Blog"}</h5>
          <button
            className="modal-close-btn"
          onClick={() => {
    setShowBlogModal(false);
    setEditingBlogId(null);
    setBlogTitle("");
    setBlogShort("");
    setBlogFull("");
    setBlogImage(null);
    setExistingImage("");
    setPublishedDate("");
  }}
          >
            ✕
          </button>
        </div>

        <div className="award-modal-body">

          {/* TITLE */}
          <input
            className="modal-input"
            placeholder="Title"
            value={blogTitle}
            onChange={(e) => {
              const value = e.target.value;

              // Allow only letters and spaces
              const cleanValue = value.replace(/[^a-zA-Z ]/g, "");

              setBlogTitle(cleanValue);
            }}
          />

          {/* AUTHOR (READONLY) */}
          <input
            className="modal-input"
            value={tutor?.full_name || tutor?.owner_name}
            disabled
          />

          {/* DATE */}
        <input
    type="date"
    value={publishedDate}
    onChange={(e) => setPublishedDate(e.target.value)}
  />

            <textarea
              className="modal-input"
              placeholder="Short Description"
              value={blogShort}
              onChange={(e) => setBlogShort(e.target.value)}
            />

        <CKEditor
    editor={ClassicEditor}
    data={blogFull}
    onChange={(event, editor) => {
      const data = editor.getData();
      setBlogFull(data);
    }}
  />

          {/* IMAGE */}
  <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}> 
    <label className="choose-image-btn">
      Choose Image
      <input
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => setBlogImage(e.target.files[0])}
      />
    </label>

    {existingImage && (
      <img
        src={`https://kalakakshaaha.com/uploads/blogs/${existingImage}`}
        alt="Blog"
        style={{ width: "120px", borderRadius: "6px" }}
      />
    )}
  </div>

        </div>

        <div className="award-modal-footer">
      <div style={{ display: "flex", gap: "12px" }}>
    <button className="fun-btn" onClick={addBlogApi}>Save</button>
    <button className="fun-btn btn-light" onClick={() => setShowBlogModal(false)}>Cancel</button>
  </div>
        </div>
      </div>
    </div>
  )}
  {/* ================= BRANCH MODAL ================= */}

  {showBranchModal &&
    createPortal(
      <div className="custom-modal-overlay">
        <div className="custom-award-modal">

          {/* HEADER */}
          <div className="custom-modal-header">
            <h5>Add Branch / Location</h5>
            <button
              className="custom-close-btn"
              onClick={() => setShowBranchModal(false)}
            >
              ✕
            </button>
          </div>

          {/* BODY */}
          <div className="custom-modal-body">

            {/* COUNTRY */}
          {/* COUNTRY */}
  <div className="custom-form-group">
    <label>Country</label>

    <select
      className="custom-input"
      value={branchForm.country}
      onChange={(e) => {
        setBranchForm({
          ...branchForm,
          country: e.target.value,
          state: "" // reset state when country changes
        });
      }}
    >
      <option value="">Select Country</option>

      {countries.map((country) => (
        <option key={country.id} value={country.id}>
          {country.country_name}
        </option>
      ))}
    </select>
  </div>


            {/* STATE */}
  {/* STATE */}
  <div className="custom-form-group">
    <label>State</label>

    <select
      className="custom-input"
      value={branchForm.state}
      onChange={(e) =>
        setBranchForm({ ...branchForm, state: e.target.value })
      }
      disabled={!branchForm.country}
    >
      <option value="">Select State</option>

      {states
        .filter((s) => String(s.country_id) === String(branchForm.country))
        .map((state) => (
          <option key={state.id} value={state.id}>
            {state.state_name}
          </option>
        ))}
    </select>
  </div>


            {/* CITY */}
            <div className="custom-form-group">
              <label>City</label>
  <input
    className="custom-input"
    list="cityList"
    placeholder="Search or select city"
    value={branchForm.city}
    onChange={(e) =>
      setBranchForm({ ...branchForm, city: e.target.value })
    }
  />

  <datalist id="cityList">
    {cities
      .filter((c) => String(c.state_id) === String(branchForm.state))
      .map((city) => (
        <option key={city.id} value={city.city_name} />
      ))}
  </datalist>

            </div>


            {/* PINCODE */}
            <div className="custom-form-group">
              <label>Pincode</label>
              <input
                className="custom-input"
                value={branchForm.pincode}
                onChange={(e) =>
                  setBranchForm({ ...branchForm, pincode: e.target.value })
                }
              />
            </div>

            {/* AREA */}
            <div className="custom-form-group">
              <label>Area</label>
              <input
                className="custom-input"
                value={branchForm.area}
                onChange={(e) =>
                  setBranchForm({ ...branchForm, area: e.target.value })
                }
              />
            </div>

            {/* LOCATION */}
            <div className="custom-form-group">
              <label>Location</label>
              <input
                className="custom-input"
                value={branchForm.location}
                onChange={(e) =>
                  setBranchForm({ ...branchForm, location: e.target.value })
                }
              />
            </div>

            {/* ADDRESS LINE 1 */}
            <div className="custom-form-group">
              <label>Address Line 1</label>
              <input
                className="custom-input"
                value={branchForm.address_line1}
                onChange={(e) =>
                  setBranchForm({
                    ...branchForm,
                    address_line1: e.target.value,
                  })
                }
              />
            </div>

            {/* ADDRESS LINE 2 */}
            <div className="custom-form-group">
              <label>Address Line 2</label>
              <input
                className="custom-input"
                value={branchForm.address_line2}
                onChange={(e) =>
                  setBranchForm({
                    ...branchForm,
                    address_line2: e.target.value,
                  })
                }
              />
            </div>

          </div>

          {/* FOOTER */}
          <div className="custom-modal-footer">
            <button className="custom-primary-btn" onClick={saveBranch}>
              Save
            </button>

            <button
              className="custom-secondary-btn"
              onClick={() => setShowBranchModal(false)}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>,
      document.body
    )
  }



            </div>
          </section>
          <UpgradeModal
            isOpen={showUpgradeModal}
            onClose={() => setShowUpgradeModal(false)}
            tutor={tutor}
            setPlanStatus={setPlanStatus}
            fetchPlan={fetchPlan}
          />
          <Footer />
          
        </Fragment>
      );
    };

    export default ViewProfile;